import Vue from 'vue'
import Router from 'vue-router'

import CaseCar from '@/view/caseCar'
import WeChat from '@/view/weChat'
import DatePlatform from '@/view/datePlatform'
import MarketingPlatform from '@/view/marketingPlatform'
import Crm from '@/view/crm'
import home from '@/view/home'
import about from '@/view/about'
import solutionConversion from '@/view/solution/conversion'
import solutionMarket from '@/view/solution/marketing'
import recruit from '@/view/recruit'

Vue.use(Router)

const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

const router = new Router({
  mode: "history",
  routes: [
    {
      path: '/',
      name: 'home',
      component: home,
      meta: {
        title: '首页',
      }
    },
    {
      path: '/about',
      name: 'about',
      component: about,
      meta: {
        title: '关于我们',
      }
    }, {
      path: '/caseCar',
      name: 'caseCar',
      component: CaseCar,
      meta: {
        title: '合作案例',
      }
    }, {
      path: '/weChat',
      name: 'weChat',
      component: WeChat,
      meta: {
        title: '企业微信应用',
      }
    },{
      path: '/datePlatform',
      name: 'datePlatform',
      component: DatePlatform,
      meta: {
        title: '客户数据平台',
      }
    },
    {
      path: '/marketingPlatform',
      name: 'marketingPlatform',
      component: MarketingPlatform,
      meta: {
        title: '智能营销平台',
      }
    },
    {
      path: '/crm',
      name: 'crm',
      component: Crm,
      meta: {
        title: 'CRM&SCRM',
      }
    },
    {
      path: '/solution-conversion',
      name: 'solution-conversion',
      component: solutionConversion,
      meta: {
        title: '解决方案',
      }
    },
    {
      path: '/solution-market',
      name: 'solution-market',
      component: solutionMarket,
      meta: {
        title: '解决方案',
      }
    },
    {
      path: '/recruit',
      name: 'recruit',
      component: recruit,
      meta: {
        title: '英檬招聘',
      }
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})

// 切换路由之后滚动条始终在最顶部
router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
})

router.beforeEach((to,from,next) => {
  window.document.title = to.meta.title || "上海英盟科技有限公司";
  next();
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js